var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { COMING_SOON_MASK_TEXT } from 'root/src/shared/constants/dropEvent';
export const maskComingSoonDare = (dare) => {
    const { paymentInfo, product } = dare, rest = __rest(dare, ["paymentInfo", "product"]);
    return Object.assign(Object.assign({}, rest), { title: COMING_SOON_MASK_TEXT, description: '', product: Object.assign(Object.assign({}, product), { rewards: undefined, platform: undefined, region: undefined, name: COMING_SOON_MASK_TEXT, id: COMING_SOON_MASK_TEXT, type: 'unknown' }), paymentInfo: Object.assign(Object.assign({}, paymentInfo), { brandProductId: COMING_SOON_MASK_TEXT, productType: 'unknown' }), hint: COMING_SOON_MASK_TEXT, estimatedTime: COMING_SOON_MASK_TEXT });
};
export const mapComingSoonDares = (dares) => {
    return dares === null || dares === void 0 ? void 0 : dares.map(dare => maskComingSoonDare(dare));
};
